import React, { useMemo } from 'react';
import Input from '@/components/input/Input';
import { Quiz, RangeQuestion } from '../../../common';
import update from 'immutability-helper';
import theme from '@/constants/theme';

interface Props {
  index: number;
  type: RangeQuestion['type'];
  options: RangeQuestion['options'];
  setQuiz: React.Dispatch<React.SetStateAction<Quiz | null>>;
}

const RangeOptions: React.FC<Props> = ({ type, options, setQuiz, index }) => {
  const handleChangeRangeOptions = (field: keyof RangeQuestion['options'], value: string) => {
    setQuiz((prevQuiz) =>
      update(prevQuiz, {
        questions: {
          [index]: {
            options: {
              [field]: { $set: value },
            },
          },
        },
      }),
    );
  };

  const msgError = useMemo(() => {
    const { max, min, step } = options;
    if (min.length === 0) {
      return 'El valor mínimo no puede estar vacío.';
    } else if (max.length === 0) {
      return 'El valor máximo no puede estar vacío.';
    } else if (Number(min) >= Number(max)) {
      return 'El valor mínimo debe ser menor que el valor máximo.';
    } else if (Number(step) <= 0) {
      return 'El valor de paso debe ser un número positivo.';
    }
    return '';
  }, [options]);

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, flexDirection: 'row', justifyContent: 'space-between' }}>
        <Input
          containerSx={{ maxWidth: 100 }}
          type="number"
          value={options.min}
          label="Valor mínimo"
          onChange={(e) => handleChangeRangeOptions('min', e.target.value)}
        />
        <Input
          containerSx={{ maxWidth: 100 }}
          type="number"
          value={options.max}
          label="Valor máximo"
          onChange={(e) => handleChangeRangeOptions('max', e.target.value)}
        />
        <Input
          containerSx={{ maxWidth: 100 }}
          type="number"
          value={options.step}
          label="Valor de paso"
          onChange={(e) => handleChangeRangeOptions('step', e.target.value)}
        />
      </div>
      <p style={{ color: theme.colors.text.body, marginTop: 8 }}>{msgError}</p>
    </div>
  );
};

export default RangeOptions;
